/* template */
<template><div :style="[(computedNavbarStyle)] | transRpxStyle" class="ts-navbar" :class='[$attrs["extern-class"],$attrs["externClass"]]'><mpx-view @tap="clickLeft" :style="[({color: leftColor})] | transRpxStyle" class="ts-navbar-left"><Icon name="navbar-back" color="#000" size="40" v-if="(leftArrow)"/><span class="ts-navbar-left-text" v-if="(left)">{{ left }}</span><slot name="left" v-else></slot></mpx-view><div :style="[(titleStyle)] | transRpxStyle" class="ts-navbar-title"><span class="ts-navbar-text" v-if="(title)">{{ title }}</span><slot v-else></slot></div><mpx-view @tap="clickRight" class="ts-navbar-right"><span v-if="(right)">{{ right }}</span><slot name="right" v-else></slot></mpx-view></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m268d26bb"}'>
  .ts-navbar
    position relative
    display flex
    width 100%
    box-sizing content-box
    padding-top env(safe-area-inset-top)
    align-items center
    justify-content center
    height 44px
    z-index 1
    text-align center
    background-color #fff
    user-select none
    line-height 20px
    &-left
      position absolute
      left 0
      display flex
      align-items center
      padding 0 16px
      font-size 25px
      &-text
        font-size 16px
    &-title
      flex 1
      flex-shrink 0
      width 0
      max-width 60%
      text-overflow ellipsis
      overflow hidden
      white-space nowrap
      font-family PingFangSC-Semibold
      font-weight 500
      font-size 18px
    &-text
      flex 1
      width 0
      overflow hidden
      white-space nowrap
      text-overflow ellipsis
    &-right
      position absolute
      right 0
      display flex
      align-items center
      padding 0 16px
      font-size 14px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m268d26bb"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex268d26bb%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex268d26bb%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m268d26bb"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index268d26bb/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'Icon':getComponent(require("../../spring-icon/index/index.mpx?isComponent&outputPath=components%2Findex4d1d0d54%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
